<template>
  <div :class="'flex flex-col h-full items-center overflow-y-hidden content-center justify-center search-container '"
  >
    <div :class="'flex flex-col search-box ' + [rxSWINSearchPageStore.searched ? ' pt-3 pb-3 searched ' : ' unsearched ']">
      <div class="flex items-center text-lg font-medium mb-2 px-5 md:px-6">
        <IconSearch class="w-6 h-6 mr-2" :stroke-width="1.5"/>
        {{ $t('pages.rx_swin_search.search.search_for_rx_swin') }}...
      </div>
      <InputText   :pt="{
     root: { 'data-cy': 'RxSWIN-search-input-box' }
  }" class="w-full" type="text" size="large" placeholder="R141_123456789"
                 v-model="rxSWINSearchPageStore.params.filter.search"
                 @change="rxSWINSearchPageStore.onSearch"
                 @keyup="rxSWINSearchPageStore.onSearch"
      />
      <Divider v-if="rxSWINSearchPageStore.searched" />
      <div class="overflow-auto">
        <Search
            v-if="rxSWINSearchPageStore.searched"
            :items="rxSWINSearchPageStore.getRxSWINs"
            :searchText="rxSWINSearchPageStore.params.filter.search"
        />
      </div>
      <Paginator
          v-if="rxSWINSearchPageStore.searched"
          v-show="!rxSWINSearchPageStore.loading"
          :pt="{
            paginatorWrapper: {
            class: ['border-t-0']
            }
          }"
          :first="rxSWINSearchPageStore.getFirstPage"
          :rows="rxSWINSearchPageStore.params.per_page"
          :rowsPerPageOptions="rxSWINSearchPageStore.pages"
          :total-records="rxSWINSearchPageStore.totalRecords"
          :loading="rxSWINSearchPageStore.loading"
          @page="rxSWINSearchPageStore.onPage($event)"
          @update:rows="rxSWINSearchPageStore.onRowsUpdate"
      >
      </Paginator>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import {mapStores} from "pinia";
import {
  IconSearch
} from '@tabler/icons-vue';
import {useRxSWINStore} from "@/stores/rxSWIN.js";
import {useRxSWINSearchPageStore} from "@/stores/pages/rxSWINSearchPage.js";
import Search from "@/Pages/RxSwinSearch/Search/Search.vue";

export default {
  name: "RxSwinSearch",
  components: {
    Search,
    PageHeading,
    IconSearch
  },
  data() {
    return {

    }
  },
  methods: {
    async search() {
      await this.rxSWINSearchPageStore.loadData();

    },
  },
  computed: {
    ...mapStores(useRxSWINStore),
    ...mapStores(useRxSWINSearchPageStore),
  },
  async mounted() {
    await this.rxSWINSearchPageStore.loadData();
  }
}
</script>

<style scoped>

.search-container {
  position: relative;
  height: 100%;
}

.search-box {
  position: absolute;
  max-height: calc(100% - 20px);
  min-height: auto;
  transition: all 0.3s ease-out;
  background: #ffffff;
  color: #334155;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  box-sizing: border-box;
  padding: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.searched {
  top: 0;
  width: 75%;
}
.unsearched {
  top: calc(50% - 100px);
  width: 60%;
  height: auto;
}


</style>